import requests, { setToken } from "./httpServices";

/**
 * Creating and managing organization administrators.
 *
 * The role itself — multi_school_admin — has shipped since July: User.schoolIds,
 * req.managedSchoolIds, the scope guard, the x-school-id header, the school
 * switcher in this app. Nothing anywhere ever wrote it, so the only one in
 * existence was made by a hand-written database update. This is the half that
 * was missing.
 *
 * Errors propagate rather than being alerted here. The screen states what
 * happened next to the thing that failed, which the global alert cannot do —
 * it has no idea which school the server refused.
 */
const OrgAdminServices = {
  /** Who holds the role, the schools each administers, and the list to pick from. */
  list: async () => {
    setToken(localStorage.getItem("token"));
    return requests.get("/admin/multi-school-admin");
  },

  /**
   * Set a person's schools. The list REPLACES what they had, so removing a
   * school is this same call with that school left out, and an empty list
   * revokes the role.
   */
  save: async (userId, schoolIds) => {
    setToken(localStorage.getItem("token"));
    return requests.put("/admin/multi-school-admin", { userId, schoolIds });
  },

  /** Find someone to give the role to. */
  searchUsers: async (query) => {
    setToken(localStorage.getItem("token"));
    return requests.get(`/admin/search-users?query=${encodeURIComponent(query)}`);
  }
};

export default OrgAdminServices;
